import { render, staticRenderFns } from "./PayrollSummaryReportFilter.vue?vue&type=template&id=954c5760&scoped=true"
import script from "./PayrollSummaryReportFilter.vue?vue&type=script&lang=js"
export * from "./PayrollSummaryReportFilter.vue?vue&type=script&lang=js"
import style0 from "./PayrollSummaryReportFilter.vue?vue&type=style&index=0&id=954c5760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954c5760",
  null
  
)

export default component.exports